// extracted by mini-css-extract-plugin
export var benefit = "slider-module--benefit--Gb7Gp";
export var benefitText = "slider-module--benefitText--8HxGO";
export var benefitsList = "slider-module--benefitsList--Q7rh1";
export var btnContained = "slider-module--btnContained--JRrhX";
export var btnOutlined = "slider-module--btnOutlined--zWRx8";
export var card = "slider-module--card--aThsM";
export var card1 = "slider-module--card1--kpMD9";
export var cardList = "slider-module--cardList--UE-Iw";
export var container = "slider-module--container--lNTGL";
export var headDescr = "slider-module--headDescr--OshAK";
export var headTitle = "slider-module--headTitle--DlLM8";
export var img = "slider-module--img--xVE+F";
export var title = "slider-module--title--zow6c";